import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  makeStyles,
  Menu,
  MenuItem,
  IconButton,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import PlayArrow from "@material-ui/icons/PlayArrow";
import { Link, useHistory } from "react-router-dom";
// Importation des images
import homeBackground from "../../images/homeBackground.jpg";
import headerIsthia from "../../images/headerIsthia.png";
import pourquoiimg from "../../images/pictos/002-like.png";
import decouvririmg from "../../images/pictos/001-binoculars.png";
const useStyles = makeStyles((theme) => ({
  mainTitle: {
    fontSize: "5vh",
    fontWeight: "bold",
    paddingTop: "9.5vh",
  },
  mainSubtitle: {
    fontSize: "2.8vh",
    fontStretch: "condensed",
    whiteSpace: "nowrap",
    fontWeight: "Bold",
  },
  centralHomeColumn: {
    backgroundImage: `url(${homeBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "60vh",
    color: "white",
  },
  text: {
    fontSize: "12px",
    textAlign: "justify",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "257px",
    marginBottom: "5%",
  },
  mainButton: {
    backgroundColor: "#E50039",
    color: "white",
    linHeight: "54px",
    fontWeight: "bold",
    fontSize: "0.95rem",
    padding: "4.5% 3%",
    borderRadius: 12,
    textTransform: "uppercase",
    textAlign: "center",
    "&:hover": {
      backgroundColor: "#E50039",
    },
    marginLeft: "auto",
    marginRight: "auto",
    width: "257px",
    display: "block",
  },
  twoButton: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: 25,
    marginLeft: "2%",
    marginRight: "2%",
    marginTop: "auto",
    marginBottom: "auto",
  },
  navButton: {
    display: "flex",
    justifyContent: "space-around",
    fontWeight: "bold",
    borderRadius: 12,
  },
  pourquoi: {
    backgroundImage: `url(${pourquoiimg})`,
    backgroundRepeat: "no-repeat",
    lineHeight: "Normal",
    color: "white",
    backgroundSize: "100%",
    width: "47%",
    height: "15vh",
    fontSize: "1.8vh",
    fontWeight: "bold",
  },
  decouvrir: {
    backgroundImage: `url(${decouvririmg})`,
    backgroundRepeat: "no-repeat",
    lineHeight: "Normal",
    color: "white",
    backgroundSize: "100%",
    width: "47%",
    height: "15vh",
    fontSize: "1.8vh",
    fontWeight: "bold",
  },
  burgerIcon: {
    color: "white",
    height: 40,
    width: 40,
    marginLeft: "2vw",
  },
}));

const Home = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const classes = useStyles();
  const history = useHistory();
  return (
    <Box
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <section className={classes.centralHomeColumn}>
        <header style={{ display: "flex", alignItems: "center" }}>
          <IconButton
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            edge="start"
          >
            <MenuIcon className={classes.burgerIcon} />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              onClick={() => {
                history.push(`/decouvrir`);
              }}
            >
              Découvrir le projet
            </MenuItem>
            <MenuItem
              onClick={() => {
                history.push(`/pourquoi`);
              }}
            >
              Pourquoi participer ?
            </MenuItem>
            <MenuItem
              onClick={() => {
                history.push(`/mentions-legales`);
              }}
            >
              Mentions légales
            </MenuItem>
            <MenuItem
              onClick={() => {
                history.push(`/politique-cookies`);
              }}
            >
              Politique de cookie
            </MenuItem>
            <MenuItem
              onClick={() => {
                history.push(`/politique-confidentialite`);
              }}
            >
              Politique de confidentialité
            </MenuItem>
          </Menu>
          <div style={{ marginLeft: "3vw" }}>
            <img
              src={headerIsthia}
              alt="logo du projet Naturr"
              style={{ width: "60vw", maxWidth: 260 }}
            />
          </div>
        </header>
        <Typography variant="h1" className={classes.mainTitle}>
          Bienvenue !
        </Typography>
        <Typography variant="h3" className={classes.mainSubtitle}>
          Nous avons besoin de vous !
        </Typography>
        <Typography
          style={{ textAlign: "center", marginBottom: 5, fontWeight: "bold" }}
        >
          ______________
        </Typography>
        <Typography variant="body1" className={classes.text}>
          N'hésitez pas à déposer vos observations sur votre environnement
          proche. <br /> Vos commentaires nous aideront à progresser dans
          l'amélioration et la protection de nos espaces, naturels ou urbains.
        </Typography>

        <Link
          to={`/observation`}
          style={{ color: "white" }}
          className={(classes.navButton, classes.mainButton)}
        >
          Je fais une observation{" "}
          <PlayArrow
            style={{
              transform: "rotate(0turn)",
              fill: "transparent",
              stroke: "white",
              verticalAlign: "middle",
            }}
          />
        </Link>
      </section>
      <section className={classes.twoButton}>
        <Button
          className={(classes.navButton, classes.decouvrir)}
          classes={{ label: "labelButton" }}
          onClick={() => {
            history.push(`/decouvrir`);
          }}
        >
          <p style={{ margin: 0 }}>Découvrir</p>
          <p style={{ margin: 0, display: "flex", whiteSpace: "nowrap" }}>
            Le projet{" "}
            <PlayArrow
              style={{
                transform: "rotate(0turn)",
                fill: "transparent",
                stroke: "white",
                verticalAlign: "middle",
              }}
            />
          </p>
        </Button>
        <Button
          className={(classes.navButton, classes.pourquoi)}
          classes={{ label: "labelButton" }}
          onClick={() => {
            history.push(`/pourquoi`);
          }}
        >
          <p style={{ margin: 0 }}>Pourquoi</p>{" "}
          <p style={{ margin: 0, display: "flex", whiteSpace: "nowrap" }}>
            Participer{" "}
            <PlayArrow
              style={{
                transform: "rotate(0turn)",
                fill: "transparent",
                stroke: "white",
                verticalAlign: "middle",
              }}
            />
          </p>
        </Button>
      </section>
    </Box>
  );
};

export default Home;
